module.exports = __webpack_public_path__ + "static/img/img_1.074570f3.jpg";